import React, { Component } from "react";


class Detalle70 extends Component {
  render(){
		return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Museo Interactivo para la Niñez y la Juventud Hidalguense El Rehilete</h2>
          </header>
    			<div>
      			<div className="col-12 center">
              <h4>Art. 70 Ley de Transparencia</h4>
      				{ this._renderCard70() }
      			</div>
    			</div> 
        </div>
      </div>
		);
  }
	_renderCard70 = (label) => {
    return ( 
      <div className="linea iconorubro col-md-4">
        <a className="linea"href="/Transparencia/Art.70LeydeTransparencia/a70_f01_g_MINJHR.xlsx" target="blank">
        <button type="button" className="btn btn-success"> XLXS</button></a>
        <a className="linea"href="/Transparencia/Art.70LeydeTransparencia/a70_f01_g_MINJHR.htm" target="blank">
        <button type="button" className="btn btn-light">Ver Tabla</button></a>
      </div>
    );
  }
}

export default Detalle70;